import { Input } from 'antd';
import { isUndefined } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';

const NumericInput = React.forwardRef((props, ref) => {
  const { onChange, defaultValue, value, ...rest } = props;

  const [inputValue, setInputValue] = useState(!isUndefined(value) ? value : defaultValue);
  const isFocusedRef = useRef(false);

  const cleanValue = val => {
    if (val === '' || val === undefined || val === null) return '';

    let tempValue = String(val);

    if (tempValue.charAt(tempValue.length - 1) === '.' || tempValue === '-') {
      tempValue = tempValue.slice(0, -1);
    }

    return tempValue.replace(/0*(\d+)/, '$1');
  };

  useEffect(() => {
    if (!isFocusedRef.current && !isUndefined(value)) {
      const cleanedPropValue = cleanValue(value);
      const cleanedCurrentValue = cleanValue(inputValue);

      if (cleanedPropValue !== cleanedCurrentValue) {
        setInputValue(cleanedPropValue);
      }
    }
  }, [value, inputValue]);

  return (
    <Input
      {...rest}
      type="string"
      ref={ref}
      value={inputValue}
      onChange={e => {
        let tempValue = e.target.value;
        tempValue =
          tempValue.charAt(0) === '-'
            ? `-${tempValue.replace(/-/gi, '')}`
            : tempValue.replace(/-/gi, '');

        if (tempValue.startsWith('.')) {
          tempValue = '0' + tempValue;
        } else if (tempValue.startsWith('-.')) {
          tempValue = '-0' + tempValue.slice(1);
        }

        const reg = /^-?\d*(\.\d*)?$/;

        if (reg.test(tempValue) || tempValue === '' || tempValue === '-') {
          tempValue = tempValue === '.' ? '0.' : tempValue;

          setInputValue(tempValue);
          if (typeof onChange === 'function') onChange(tempValue);
        } else {
          const initialValue = !isUndefined(inputValue) ? inputValue : '';
          setInputValue(initialValue);
          if (typeof onChange === 'function') onChange(initialValue);
        }
      }}
      onFocus={() => {
        isFocusedRef.current = true;
      }}
      onBlur={({ target }) => {
        const cleanedValue = cleanValue(target.value);
        setInputValue(cleanedValue);
        if (typeof onChange === 'function') onChange(cleanedValue);

        isFocusedRef.current = false;

        // After blur, sync with value prop if it differs
        if (!isUndefined(value)) {
          const cleanedPropValue = cleanValue(value);
          if (cleanedPropValue !== cleanedValue) {
            setInputValue(cleanedPropValue);
            if (typeof onChange === 'function') onChange(cleanedPropValue);
          }
        }
      }}
    />
  );
});

export default NumericInput;
